export default __webpack_public_path__ + "static/media/registration-illustration.da6c3d57.png";